<c-container class="mt-4 mb-5">
  <!-- Filter Selection -->
  <div class="mb-4">
    <div class="d-flex gap-2 border-bottom align-items-end">
      <div class="d-flex flex-column gap-2">
        <label class="small fw-semibold text-secondary text-uppercase ps-2 mb-0">App Type</label>
        <div class="filter-buttons d-flex gap-2">
          @if (canEditAdminAppFaqs) {
            <button mat-button
                    [ngClass]="{'active': selectedAppType() === FaqScopeTypes.AdminApp}"
                    (click)="onAppTypeChange(FaqScopeTypes.AdminApp)"
                    data-testid="app-type-admin-app">
              <mat-icon class="me-2">admin_panel_settings</mat-icon>
              Admin App
            </button>
          }
          @if (canEditWebappFaqs) {
            <button mat-button
                    [ngClass]="{'active': selectedAppType() === FaqScopeTypes.WebApp}"
                    (click)="onAppTypeChange(FaqScopeTypes.WebApp)"
                    data-testid="app-type-webapp">
              <mat-icon class="me-2">web</mat-icon>
              Webapp
            </button>
          }
        </div>
      </div>

      <div class="tab-divider mx-3 align-self-end"></div>

      <div class="d-flex flex-column gap-2">
        <label class="small fw-semibold text-secondary text-uppercase ps-2 mb-0">Scope</label>
        <div class="filter-buttons d-flex gap-2">
          <button mat-button
                  [ngClass]="{'active': currentFilter() === FaqFilterType.GameSpecific}"
                  (click)="onFilterChange(FaqFilterType.GameSpecific)"
                  [disabled]="!selectedAppType()"
                  data-testid="scope-filter-game-specific">
            <mat-icon class="me-2">videogame_asset</mat-icon>
            Game-Specific
          </button>
          <button mat-button
                  [ngClass]="{'active': currentFilter() === FaqFilterType.Shared}"
                  (click)="onFilterChange(FaqFilterType.Shared)"
                  [disabled]="!selectedAppType()"
                  data-testid="scope-filter-shared">
            <mat-icon class="me-2">public</mat-icon>
            Shared
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (selectedAppType()) {

    <!-- Step 3: Game Selector (only for Game-Specific, and only when the header has no game selected) -->
    @if (currentFilter() === FaqFilterType.GameSpecific && !gameFromScope) {
      <div class="mb-4">
        <app-choose-your-game
          [message]="'Choose a game to manage FAQs'"
          (gameChosenEvent)="onGameChosen($event)">
        </app-choose-your-game>
      </div>
    }

    <!-- FAQs Grid -->
    @if (currentFilter() === FaqFilterType.Shared || selectedGame()) {
      <div class="mb-3">
        <div class="d-flex justify-content-end">
          <button mat-raised-button
                  color="primary"
                  (click)="onAddFaqClick()"
                  matTooltip="Add new FAQ"
                  matTooltipShowDelay="500"
                  data-testid="add-new-frequently-asked-question">
            <mat-icon>add_circle</mat-icon>
            Add FAQ
          </button>
        </div>
      </div>

      @if (uiState === UIStateEnum.ShowData) {
        <ag-grid-angular
          class="ag-theme-quartz faq-grid"
          data-testid="faqs-table"
          [tooltipShowDelay]=0
          [autoSizeStrategy]="autoSizeStrategy"
          [domLayout]="'autoHeight'"
          [rowHeight]="60"
          [defaultColDef]="defaultColDef"
          overlayNoRowsTemplate="<span class='d-flex align-items-center justify-content-center p-4 text-secondary'>No FAQs match the current filter</span>"
          (gridReady)="onFAQGridReady($event)"
          [rowData]="filteredFaqs()"
          [columnDefs]="faqDefs">
        </ag-grid-angular>
      } @else if (uiState === UIStateEnum.ShowLoading) {
        <div class="d-flex flex-column align-items-center justify-content-center p-5">
          <mat-spinner></mat-spinner>
          <p class="mt-3 text-muted">Loading FAQs...</p>
        </div>
      }
    } @else if (currentFilter() === FaqFilterType.GameSpecific) {
      <div class="text-center mt-5 p-5">
        <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #999;">videogame_asset</mat-icon>
        <h4 class="mt-3 text-muted">Please select a game to manage FAQs</h4>
      </div>
    }
  }
</c-container>
